import React from "react";
import styles from "../../Styles/CreatorDash/styles.module.css";
import DeleteAccount from "../Modals/DeleteAccount";
const Delete = () => {
  const [open, setOpen] = React.useState(false);
  const { role } = atob(JSON.parse(localStorage.getItem("_access_token")).split(".")[1]);
  return (
    <div className={styles.delete}>
      <div className={styles.deltext}>
        <span>Are you sure you want to delete your account permantly?</span>
        <br />
        {role === "creator" && (
          <span>All links to your playlists will be lost from this website</span>
        )}
      </div>
      <div className={styles.delbut}>
        <button onClick={() => setOpen((val) => !val)}>Delete Account</button>
      </div>
      {open && <DeleteAccount open={open} setOpen={setOpen} />}
    </div>
  );
};
export default Delete;
